import { useToast } from '@chakra-ui/react';
import { QueryKey, useQuery } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import { useAxios } from 'context/AxiosContextProvider';
import { manageErrorResponse } from 'helpers/manageErrorResponse';
import { useEffect } from 'react';

import { PaginatedChains } from '../api/types';
import config from '../config';

async function getChain(props: { axios: AxiosInstance; searchString: string; itemsPerPage: number; page?: number }): Promise<PaginatedChains> {
  const { axios, searchString, itemsPerPage, page } = props;

  const { data } = await axios.get(`${config.apiBaseUrl}/op/v1/chain`, {
    params: {
      searchString: searchString || '',
      itemsPerPage,
      page,
    },
  });
  return data;
}

export default function useChainsQuery(searchString: string, itemsPerPage: number, page?: number) {
  const axios = useAxios();
  const toast = useToast();

  const query = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: getKey(searchString, itemsPerPage, page),
    queryFn: () => getChain({ axios, searchString, itemsPerPage, page }),
    notifyOnChangeProps: ['data', 'isFetching', 'error'],
    retry: false,
    refetchOnMount: 'always',
  });

  useEffect(() => {
    if (query.isError) {
      manageErrorResponse(toast, query.error as any);
    }
  }, [query.error, query.isError, toast]);

  return query;
}

function getKey(searchString: string, itemsPerPage: number, page?: number) {
  return ['Chains', searchString, itemsPerPage, page] as const satisfies QueryKey;
}

useChainsQuery.getKey = getKey;
